import { render, staticRenderFns } from "./TaskChat.vue?vue&type=template&id=6d2b1326&scoped=true"
import script from "./TaskChat.vue?vue&type=script&lang=js"
export * from "./TaskChat.vue?vue&type=script&lang=js"
import style0 from "./TaskChat.vue?vue&type=style&index=0&id=6d2b1326&prod&lang=scss&scoped=true"
import style1 from "./TaskChat.vue?vue&type=style&index=1&id=6d2b1326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b1326",
  null
  
)

export default component.exports